module.exports = __webpack_public_path__ + "static/media/bertholdbakker.c5270cc1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bertholdbakker.webp
// module id = 243
// module chunks = 0